import { Box, Typography } from "@mui/material";
import SuitItem from "../../TarotDecks/SuitItem";
interface ViewDetailDeckProps {
  deck: any;
}
const ViewDetailDeck = ({ deck }: ViewDetailDeckProps) => {
  return (
    <Box
      sx={{
        padding: "10p",
      }}
    >
      <Typography>Deck detail</Typography>
      {Array.isArray(deck.suits) ? (
        <>
          {deck.suits.map((suit: any) => (
            <SuitItem key={suit.id} suit={suit} />
          ))}
        </>
      ) : (
        <></>
      )}
    </Box>
  );
};
export default ViewDetailDeck;
